import { apiClient } from "../../base/ApiClient";

export const getDashboardStats = async () => {
  const response = await apiClient.get("/core/dashboard-stats/");
  return response.data;
};